(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["watchitude-header"]) return;
  try {
    
  /* <details> opens and closes itself; the one case it cannot handle is
     a link that never leaves the page. A same-page anchor such as
     /#flavour only changes the hash, so the drawer would stay open on
     top of the section the visitor just jumped to. Closing it on any
     link click inside the drawer covers that, and costs nothing on a
     real navigation, where the next page renders it closed anyway.

     Delegated from the document rather than bound to the element: this
     bundle is shared across sections and runs once, with no guarantee
     the header is in the DOM at the time. */
  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || typeof target.closest !== 'function') return;

    /* Requiring an <a> is what keeps the summary from tripping this --
       a click on the summary is how the drawer gets opened. */
    var link = target.closest('.wt-header__drawer a');
    if (!link) return;

    var drawer = link.closest('.wt-header__drawer');
    if (drawer) drawer.open = false;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["watchitude-home"] && !Shopify.designMode) return;
  try {
    
  /* Hero image switcher (#top). Drives both pill groups: the feature's
     flavours and the endless bubble card's two sizes.

     All the state is one attribute -- data-wt-option on whichever block
     the pills sit in -- and the CSS does the rest: the cross-fade and the
     active pill both key off it. So every handler here does the same one
     thing, and nothing has to read the DOM to find out what is currently
     showing.

     Delegated from the document rather than bound to the pills: this
     bundle is shared across sections and runs once, with no guarantee
     the hero is in the DOM at the time, and a theme-editor re-render
     replaces the pills without re-running it.

     mouseout and focusout stand in for mouseleave and blur because only
     the bubbling pair reaches a delegated listener; the relatedTarget
     test in release() is what turns them back into "left the group". */
  (function () {
    var GROUP = '.wt-hero__pills';

    function groupFrom(node) {
      if (!node || typeof node.closest !== 'function') return null;
      return node.closest(GROUP);
    }

    function pillFrom(node) {
      if (!node || typeof node.closest !== 'function') return null;
      return node.closest(GROUP + ' [data-wt-option]');
    }

    /* The root is whichever block carries the attribute -- the feature
       panel or the bubble card. Climbing to it rather than naming it is
       the whole of what makes one switcher serve both. */
    function show(group, option) {
      var root = group.closest('[data-wt-option]');
      if (!root) return;

      root.setAttribute('data-wt-option', option);

      var pills = group.querySelectorAll('[data-wt-option]');
      var active = null;
      for (var i = 0; i < pills.length; i++) {
        var isActive = pills[i].getAttribute('data-wt-option') === option;
        if (isActive) active = pills[i];
        pills[i].classList.toggle('wt-hero__pill--active', isActive);

        /* Only the pills that ship the attribute get it maintained --
           the tag'd dots, whose white fill is the only thing that says
           which style is showing. The labelled pills elsewhere say it in
           words, so they are left as plain buttons. */
        if (pills[i].hasAttribute('aria-pressed')) {
          pills[i].setAttribute('aria-pressed', isActive ? 'true' : 'false');
        }
      }

      /* Only the tag'd dots ship a url, because only that card is nine
         separate products behind one picture. The flavour and bubble
         cards are one product each and keep the link they rendered
         with, so the absence of the attribute is the whole condition --
         nothing here needs to know which card it is looking at. */
      var url = active && active.getAttribute('data-wt-url');
      var link = url && root.querySelector('[data-wt-card-link]');
      if (link) link.setAttribute('href', url);
    }

    /* The first pill is the default, so a group states its own fallback
       instead of this file knowing that one starts on sushi and the
       other on full size. */
    function defaultOption(group) {
      var first = group.querySelector('[data-wt-option]');
      return first ? first.getAttribute('data-wt-option') : null;
    }

    /* Hover is a preview and a click is a choice, and only the second
       survives the pointer leaving. Without the difference the tag'd
       caret would be pointless: it advances the card, and then brushing
       the dot row on the way past would drop it back to the first style.

       Kept on the group as an attribute so nothing has to be initialised
       -- a group that has never been clicked simply has none, and falls
       back to the first pill exactly as before. */
    function committed(group) {
      return group.getAttribute('data-wt-committed') || defaultOption(group);
    }

    function commit(group, option) {
      group.setAttribute('data-wt-committed', option);
      show(group, option);
    }

    /* Hover and keyboard focus are the same gesture as far as the hero is
       concerned, so they share a handler. */
    function activate(event) {
      var pill = pillFrom(event.target);
      if (!pill) return;
      show(pill.closest(GROUP), pill.getAttribute('data-wt-option'));
    }

    function release(event) {
      var group = groupFrom(event.target);
      if (!group) return;

      /* Moving between two pills never leaves the group. */
      if (group.contains(event.relatedTarget)) return;

      /* The pointer wandering off should not yank the image out from
         under someone who tabbed to a pill and is still sitting on it. */
      if (group.contains(document.activeElement)) return;

      var fallback = committed(group);
      if (fallback) show(group, fallback);
    }

    document.addEventListener('mouseover', activate);
    document.addEventListener('focusin', activate);
    document.addEventListener('mouseout', release);
    document.addEventListener('focusout', release);

    /* Touch has no hover to switch on, so the tap has to do it. Sushi,
       ice cream and burger are real links and are left alone; every other pill is a
       button with nowhere to go, so its default is swallowed -- on the
       bubble card that is also what keeps the tap off the card's own
       stretched link. */
    document.addEventListener('click', function (event) {
      var pill = pillFrom(event.target);
      if (!pill || pill.tagName === 'A') return;

      event.preventDefault();
      commit(pill.closest(GROUP), pill.getAttribute('data-wt-option'));
    });

    /* The tag'd card's caret. It has no option of its own -- it reads
       the one the card is showing and takes the next, wrapping at the
       end, so nine styles need one button and no numbering.

       It asks the pills for the order rather than counting products:
       they are already the list, in the order the card draws them. */
    document.addEventListener('click', function (event) {
      if (!event.target || typeof event.target.closest !== 'function') return;

      var caret = event.target.closest('[data-wt-next]');
      if (!caret) return;

      event.preventDefault();

      var root = caret.closest('[data-wt-option]');
      var group = root && root.querySelector(GROUP);
      if (!group) return;

      var options = group.querySelectorAll('[data-wt-option]');
      if (!options.length) return;

      var current = root.getAttribute('data-wt-option');
      var index = 0;
      for (var i = 0; i < options.length; i++) {
        if (options[i].getAttribute('data-wt-option') === current) {
          index = i;
          break;
        }
      }

      var following = options[(index + 1) % options.length];
      commit(group, following.getAttribute('data-wt-option'));
    });
  })();

  /* Colour swatches on both bubble cards (#bubble). Hovering one puts
     that colour in the card photo above it; leaving the row puts the
     default back. It serves the full-size card's six named dots and the
     2Go card's eighteen photographed ones without knowing which is
     which -- a row states its colours in the markup, and the card it is
     answering for is whichever one it sits in.

     Nothing like the hero switcher above, and deliberately so. There the
     state is an attribute and the CSS cross-fades between images that
     are all already in the DOM, which is affordable at two or six. Over
     both rows here it is twenty-four, so the photo is one <img> and this
     swaps its src. The trade is a possible blink on a colour's first
     showing, which is what warm() buys back: the first time a pointer
     touches a row, that row's colours are fetched into the browser
     cache, and by the time it has crossed the first swatch the rest are
     already there. A visitor who hovers one card never pays for the
     other.

     Delegated from the document for the same reasons as the hero: shared
     bundle, no guarantee the card is in the DOM yet, and a theme-editor
     re-render replaces the row without re-running this. */
  (function () {
    var ROW = '[data-wt-swatches]';
    var SWATCH = ROW + ' [data-wt-photo]';
    var warmed = [];

    function rowFrom(node) {
      if (!node || typeof node.closest !== 'function') return null;
      return node.closest(ROW);
    }

    function show(row, src) {
      var card = row.closest('.wt-bubble__card');
      var img = card && card.querySelector('.wt-bubble__img');

      /* No src means the card fell back to the theme-setting photo,
         which is a different element and not ours to swap. */
      if (!img || !src) return;
      if (img.getAttribute('src') === src) return;

      /* Only the src moves. The alt names the product, and the product
         is the same one in every photo the row offers -- the colours it
         names are named in the row's own label, not here. */
      img.setAttribute('src', src);
    }

    /* Once per row, and only on the first pointer that reaches it: a
       visitor who never goes near the swatches never pays for this. */
    function warm(row) {
      if (warmed.indexOf(row) !== -1) return;
      warmed.push(row);

      var swatches = row.querySelectorAll('[data-wt-photo]');
      for (var i = 0; i < swatches.length; i++) {
        var preload = new Image();
        preload.src = swatches[i].getAttribute('data-wt-photo');
      }
    }

    function activate(event) {
      var row = rowFrom(event.target);
      if (!row) return;

      warm(row);

      var swatch = event.target.closest(SWATCH);
      if (swatch) show(row, swatch.getAttribute('data-wt-photo'));
    }

    function release(event) {
      var row = rowFrom(event.target);
      if (!row) return;

      /* Moving between two swatches never leaves the row. */
      if (row.contains(event.relatedTarget)) return;

      var card = row.closest('.wt-bubble__card');
      var img = card && card.querySelector('.wt-bubble__img');
      if (img) show(row, img.getAttribute('data-wt-photo-default'));
    }

    document.addEventListener('mouseover', activate);
    document.addEventListener('mouseout', release);

    /* Touch has no hover, so the tap has to do it, and there is no
       matching "off" gesture to put the default back -- the colour that
       was tapped stays up until another one is. Which is the right way
       round for a row of colours: on a phone it behaves like a picker,
       and the swatches are plain images with nothing to navigate to, so
       there is no default to swallow. */
    document.addEventListener('click', function (event) {
      var row = rowFrom(event.target);
      if (!row) return;

      var swatch = event.target.closest(SWATCH);
      if (swatch) show(row, swatch.getAttribute('data-wt-photo'));
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
